(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/wallet-components/assets/javascripts/wallet-selector.js') >= 0) return;  svs.modules.push('/components/tipsen/wallet-components/assets/javascripts/wallet-selector.js');
"use strict";

const _svs$ui$reactForm = svs.ui.reactForm,
  ControlGroup = _svs$ui$reactForm.ControlGroup,
  Select = _svs$ui$reactForm.Select,
  Option = _svs$ui$reactForm.Option;
const _ReactRedux = ReactRedux,
  useDispatch = _ReactRedux.useDispatch;
const format = svs.utils.format;
const setActiveWallet = svs.components.tipsen.wallet.actions.setActiveWallet;
const WalletSelector = _ref => {
  let wallets = _ref.wallets,
    selectedWallet = _ref.selectedWallet;
  const dispatch = useDispatch();
  const handleClick = val => {
    dispatch(setActiveWallet(val));
  };
  return React.createElement(ControlGroup, {
    v2: true
  }, React.createElement(Select, {
    "data-testid": "mkp-wallet-selector",
    onChange: event => handleClick(event.target.value),
    v2: true,
    value: selectedWallet && String(selectedWallet.id)
  }, wallets.map(wallet => React.createElement(Option, {
    key: wallet.id,
    value: String(wallet.id)
  }, "".concat(wallet.label), wallet.meta && wallet.meta.balance ? " (".concat(format.Currency(wallet.meta.balance), " kr)") : null))));
};
setGlobal('svs.components.tipsen.walletComponent.WalletSelector', WalletSelector);

 })(window);